export const getFilenameFromFirebaseUrl = (url: string): string => {
	if (!url) return ''
	const path = url.split('?')[0] // remove query string
	const decoded = decodeURIComponent(path) // convert %2F to /
	const parts = decoded.split('/')
	return parts[parts.length - 1] // last part is the filename
}
